(function () {
  'use strict';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function initSlider(root) {
    if (root.dataset.heroSliderInit === 'true') return;
    root.dataset.heroSliderInit = 'true';

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('.split-hero__slide')
    );
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(
      root.querySelectorAll('.split-hero__dot')
    );

    var autoplay = parseInt(root.dataset.autoplay, 10);
    if (isNaN(autoplay)) autoplay = 0;
    var intervalMs = autoplay > 0 ? autoplay * 1000 : 0;

    var current = 0;
    var timer = null;

    function show(index) {
      index = (index + slides.length) % slides.length;
      if (index === current) return;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      slides[index].classList.add('is-active');
      slides[index].removeAttribute('aria-hidden');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      if (dots[index]) {
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-selected', 'true');
      }
      current = index;
    }

    function next() {
      show(current + 1);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (intervalMs > 0 && !reduceMotion) {
        timer = setInterval(next, intervalMs);
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.dotIndex, 10) || 0);
        start();
      });
    });

    // Pause on hover / focus within.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Pause when tab is hidden.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    // Touch / pointer swipe.
    var startX = 0;
    var startY = 0;
    var tracking = false;

    root.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
        stop();
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches && e.changedTouches[0];
        if (!touch) {
          start();
          return;
        }
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) {
            next();
          } else {
            show(current - 1);
          }
        }
        start();
      },
      { passive: true }
    );

    start();
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('[data-hero-slider]');
    Array.prototype.forEach.call(roots, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor: re-init when a section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
